// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-notif {
    padding: 10px;
    border-radius: 4px;
    height: auto;
    display: -webkit-flex;
    display: flex;
    border-left: 3px solid !important;
    -webkit-justify-content: flex-start;
    justify-content:flex-start;
    margin-bottom: 20px;
    
}

.success {
    color: #067A3D;
    background-color: #DFF0D8;
    border: 1px solid #D1E8CE;
    border-left-color: #067A3D;
}

.failure {
    color: #BC111E;
    background-color: #f2dede;
    border: 1px solid #EDCBCB;
    border-left-color: #BC111E;
}

.hide-icon{
  order:3;
  cursor: pointer;
}

.alert-icon{
  order:1;
  width:10px;
}

.notif-content{
  order:2;
  margin-left: 20px;
  flex-grow:1;
  font-size: 15px;
  font-stretch: normal;
  margin-top:2px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/componentStyles/notificationBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,iCAAiC;IACjC,mCAAmC;IACnC,0BAA0B;IAC1B,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;EACE,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB","sourcesContent":[".block-notif {\n    padding: 10px;\n    border-radius: 4px;\n    height: auto;\n    display: -webkit-flex;\n    display: flex;\n    border-left: 3px solid !important;\n    -webkit-justify-content: flex-start;\n    justify-content:flex-start;\n    margin-bottom: 20px;\n    \n}\n\n.success {\n    color: #067A3D;\n    background-color: #DFF0D8;\n    border: 1px solid #D1E8CE;\n    border-left-color: #067A3D;\n}\n\n.failure {\n    color: #BC111E;\n    background-color: #f2dede;\n    border: 1px solid #EDCBCB;\n    border-left-color: #BC111E;\n}\n\n.hide-icon{\n  order:3;\n  cursor: pointer;\n}\n\n.alert-icon{\n  order:1;\n  width:10px;\n}\n\n.notif-content{\n  order:2;\n  margin-left: 20px;\n  flex-grow:1;\n  font-size: 15px;\n  font-stretch: normal;\n  margin-top:2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
